// extracted by mini-css-extract-plugin
export default {"container":"PaginationWithInfo_container__rc8KJ"};